import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { EuiCodeBlock } from '../../../../../src/components/code';
import { EuiButtonEmpty } from '../../../../../src/components/button'; // @ts-ignore Not TS

import { CodeSandboxLink } from '../../codesandbox'; // @ts-ignore Not TS

import { renderJsSourceCode } from '../_utils';
export var GuideSectionExampleCode = ({
  code
}) => {
  const [codeToRender, setCodeToRender] = useState();
  useEffect(() => {
    setCodeToRender(renderJsSourceCode(code));
    return () => {
      setCodeToRender(undefined);
    };
  }, [code]);
  const codeSandboxLink = <CodeSandboxLink className="guideSectionExampleCode__link" content={code.default}>
      <EuiButtonEmpty size="xs" iconType="logoCodesandbox">
        Try out this demo on Code Sandbox
      </EuiButtonEmpty>
    </CodeSandboxLink>;
  return <>
      <EuiCodeBlock language={'javascript'} overflowHeight={400} isCopyable>
        {codeToRender}
      </EuiCodeBlock>
      {codeSandboxLink}
    </>;
};
GuideSectionExampleCode.propTypes = {
  code: PropTypes.any.isRequired
};

try {
  GuideSectionExampleCode.__docgenInfo = {
    description: '',
    displayName: 'GuideSectionExampleCode',
    methods: [],
    props: {
      code: {
        defaultValue: null,
        description: '',
        name: 'code',
        parent: undefined,
        required: true,
        type: {
          name: 'any'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}